package com.netguru.multiplatform.charts.grid

import androidx.compose.foundation.layout.*
import androidx.compose.runtime.*
import androidx.compose.ui.*
import androidx.compose.ui.layout.*
import androidx.compose.ui.unit.*
import kotlin.math.*

@Composable
internal fun YAxisLabels(
    horizontalGridLines: List<LineParameters>,
    yAxisMarkerLayout: @Composable (value: Number) -> Unit,
) {
    Box(
        modifier = Modifier
            .width(IntrinsicSize.Max)
            .fillMaxHeight()
            .padding(end = 8.dp)
    ) {
        horizontalGridLines.forEach { horizontalLine ->
            Box(
                modifier = Modifier
                    .alignCenterToOffsetVertical(horizontalLine.position)
            ) {
                yAxisMarkerLayout(horizontalLine.value)
            }
        }
    }
}

private fun Modifier.alignCenterToOffsetVertical(
    offsetToAlignWith: Float,
) = layout { measurable, constraints ->
    val placeable = measurable.measure(constraints)
    val placeableY = (offsetToAlignWith - (placeable.height / 2f)).coerceAtLeast(0f)

    layout(placeable.width, placeable.height) {
        placeable.placeRelative(0, placeableY.roundToInt())
    }
}

internal fun Modifier.alignCenterToOffsetHorizontal(
    offsetToAlignWith: Float,
) = layout { measurable, constraints ->
    val placeable = measurable.measure(constraints)
    val placeableX = offsetToAlignWith - (placeable.width / 2f)

    layout(placeable.width, placeable.height) {
        placeable.placeRelative(placeableX.roundToInt(), 0)
    }
}
